export default __webpack_public_path__ + "static/media/feedifyLogo.84dd70fb.png";